import axios from 'axios'
import config from '../apiConfig'
import url from '../baseUrl'

let baseUrl = url.salaryUrl
    //let baseUrl = "http://localhost:18081";


function randomNum(minNum, maxNum) {
  return parseInt(Math.random() * (maxNum - minNum + 1) + minNum, 10);
}
function postDown(url,params){ 
 axios.post( url,
    params,
    {
      responseType: "blob",
    }
  )
  .then((response) => {
    let str = response.headers["content-disposition"]
      .split(";")[1]
      .split("=")[1];
    let fileName = decodeURI(str);
    if (window.navigator.msSaveOrOpenBlob) {
      // 兼容 IE 10
      navigator.msSaveBlob(new Blob([response.data]), fileName);
    } else {
      let url = window.URL.createObjectURL(new Blob([response.data]));
      let link = document.createElement("a");
      link.style.display = "none";
      link.href = url;
      link.setAttribute("download", `${fileName}`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
    //   this.importFileLoading = false;
  })
  .catch((response) => {
    console.log(response);
    //   let fileName = '导出了.xlsx';
    let fileName = Date.parse(new Date()) + randomNum(1, 1200) + '.xlsx';
    console.log(fileName);
    if (window.navigator.msSaveOrOpenBlob) {
      // 兼容 IE 10
      navigator.msSaveBlob(new Blob([response.data]), fileName);
    } else {
      let url = window.URL.createObjectURL(new Blob([response.data]));
      let link = document.createElement("a");
      link.style.display = "none";
      link.href = url;
      link.setAttribute("download", `${fileName}`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
    //   this.importFileLoading = false;
  });
}
//查询服务项数据
const $ajaxSelectServiceItemByPage = params => axios.post(baseUrl + '/serviceItem/selectServiceItemByPage', params, config);
//新增服务项
const $ajaxAddServiceItem = params => axios.post(baseUrl + '/serviceItem/addServiceItem', params);
//删除
const $ajaxUpdateServiceItemState = params => axios.post(baseUrl + '/serviceItem/updateServiceItemState', params, config);
// 根据服务站查询商家/worker/listByStage
const $ajaxWorkerListByStage = params => axios.get(baseUrl + '/restapi/worker/selectByStationId', { params });
// 设置服务者 /serviceItem/setServiceWorker
const $ajaxSetServiceWorker = params => axios.post(baseUrl + '/serviceItem/setServiceWorker', params);
// 查询打卡图片字典数据
const $ajaxserviceItemGetAllImgs = params => axios.get(baseUrl + '/serviceItem/getAllImgs', { params });
// 修改服务项对应打卡图片/serviceItem/updateItemImg
const $ajaxserviceItemUpdateItemImg = params => axios.post(baseUrl + '/serviceItem/updateItemImg', params);

//查询来源/分页 source/selectSourceByPage
const $ajaxSelectSourceByPage = params => axios.post(baseUrl + '/source/selectSourceByPage', params, config);
//来源停用
const $ajaxUpdateSourceStateClose = params => axios.post(baseUrl + '/source/updateSourceStateClose', params);
//来源启用
const $ajaxUpdateSourceStateOpen = params => axios.post(baseUrl + '/source/updateSourceStateOpen', params);
//新增来源
const $ajaxAddSource = params => axios.post(baseUrl + '/source/addSource', params);
//编辑来源
const $ajaxUpdateSource = params => axios.post(baseUrl + '/source/updateSource', params);
//查询来源
const $ajaxSelectSource = params => axios.get(baseUrl + '/source/selectSource', params);
//查询门店/分页
const $ajaxSelectUnitByPage = params => axios.post(baseUrl + '/unit/selectUnitByPage', params, config);
//新增单位
const $ajaxAddUnit = params => axios.post(baseUrl + '/unit/addUnit', params);
//编辑单位
const $ajaxUpdateUnit = params => axios.post(baseUrl + '/unit/updateUnit', params);
//单位停用
const $ajaxUpdateUnitStateClose = params => axios.post(baseUrl + '/unit/updateStateClose', params);
//单位启用
const $ajaxUpdateUnitStateOpen = params => axios.post(baseUrl + '/unit/updateStateOpen', params);
// 查询所有用户 /cityStation/selectAllUser
// const $ajaxSelectAllUser = params => axios.get(baseUrl + '/cityStation/selectAllUser', { params });


//排班管理里条件查询排班
const $ajaxSelectScheduleWhereTeam = params => axios.post(baseUrl + '/schedule/selectScheduleWhereTeam', params);
//新增档期
const $ajaxAddNewSchedule = params => axios.post(baseUrl + '/schedule/addNewSchedule', params);
//查询班组
const $ajaxSelectTeamByQuerry = params => axios.post(baseUrl + '/schTeam/selectTeamByQuerry', params);
//查询所有排班
const $ajaxSelectAllTeam = params => axios.post(baseUrl + '/schTeam/selectAllTeam', params, config);
//添加班组
const $ajaxAddNewTeam = params => axios.post(baseUrl + '/schTeam/addNewTeam', params);
//编辑排班
const $ajaxUpdateTeamInfo = params => axios.post(baseUrl + '/schTeam/updateTeamInfo', params);
// 根据单位编号查询区域 GET /unit/selectRegionByUnitNo
const $ajaxSelectRegionByUnitNo = params => axios.get(baseUrl + '/unit/selectRegionByUnitNo', {
        params
    }, config)
    //变更区域     /unit/updateUnitRegion
const $ajaxUpdateUnitRegion = params => axios.post(baseUrl + '/unit/updateUnitRegion', params)
    //查询技能下拉列表
const $ajaxSelectEmSkillList = params => axios.get(baseUrl + '/restapi/getAllSkill', { params }, config)
    // 条件查询档期与占用 /occupy/selectOccupyByQuery
const $ajaxSelectOccupyByQuery = params => axios.post(baseUrl + '/occupy/selectOccupyByQuery', params)
    // 删除档期
    const $ajaxDeleteOccupy= params => axios.get(baseUrl + '/occupy/deleteOccupy',{ params})
    //停用班组
const $ajaxUpdateTeamState = params => axios.post(baseUrl + '/schTeam/updateTeamState', params);
//获取已设置商家技能列表 /workerServiceItem/list

const $ajaxWorkerServiceItemList = params => axios.get(baseUrl + '/workerServiceItem/list', { params });
// 删除商家技能 /workerServiceItem/delete
const $ajaxWorkerServiceItemDelete = params => axios.get(baseUrl + '/workerServiceItem/delete', { params });
//修改服务者技能
const $ajaxWorkerServiceItemUpdate = params => axios.post(baseUrl + '/workerServiceItem/update', params);
//追加服务者技能
const $ajaxBatchAppendServiceItem = params => axios.post(baseUrl + '/workerServiceItem/batchAppendServiceItem', params);

// 查询所有城市 GET /cityStation/selectAllCity
const $ajaxSelectAllCity = params => axios.get(baseUrl + '/cityStation/getallCity', { params });
// 查询所有服务站
const $ajaxSelectStation = params => axios.get(baseUrl + '/restapi/citystation/selectStation2', { params });

//服务者同城-请假列表
const $ajaxgetWorkerLeaveList = params => axios.get(baseUrl + '/tbWorkerLeave/getWorkerLeaveList', { params });

const $ajaxsaveWorkerLeave = params => axios.post(baseUrl + '/tbWorkerLeave/saveWorkerLeave', params);
//服务者档期日历查询*****不要经纬度技能
const $getStockNoLngLat = params => axios.post(baseUrl + '/restapi/getStockNoLngLat', params);
//盒马的供应商查档期日历
const $getStockNoLngLatV2 = params => axios.post(baseUrl + '/occupy/getStockNoLngLatV2', params);


//盒马假人查询列表
const $ajaxgetDispWorkerList = params => axios.get(baseUrl + '/hmDispatchOrder/getDispWorkerList', { params });

//盒马假人派单设置
const $ajaxUpdateState = params => axios.get(baseUrl + '/hmDispatchOrder/updateState', { params });
//盒马人员的服务站
const $ajaxgetDispCity = params => axios.get(baseUrl + '/hmDispatchOrder/getDispCity', { params });
//修改或添加
const $ajaxaddOrUpdate = params => axios.post(baseUrl + '/hmDispatchOrder/addOrUpdate',  params );
//删除
const $ajaxDeleteDispWorker = params => axios.get(baseUrl + '/hmDispatchOrder/deleteDispWorker', { params });

//统计服务者技能排班接单点
const $ajaxworkerSchReportGetList = params => axios.post(baseUrl + '/workerSchReport/getList',  params );
const  $ajaxworkerSchReportDown= params => postDown(baseUrl + '/workerSchReport/getList',params);


export default {
    $ajaxSelectServiceItemByPage,
    $ajaxAddServiceItem,
    $ajaxUpdateServiceItemState,
    $ajaxWorkerListByStage,
    $ajaxSetServiceWorker,
    $ajaxserviceItemUpdateItemImg,
    $ajaxserviceItemGetAllImgs,
    $ajaxSelectSourceByPage,
    $ajaxUpdateSourceStateClose,
    $ajaxUpdateSourceStateOpen,
    $ajaxAddSource,
    $ajaxUpdateSource,
    $ajaxSelectSource,
    $ajaxSelectUnitByPage,
    $ajaxAddUnit,
    $ajaxUpdateUnit,
    $ajaxUpdateUnitStateOpen,
    $ajaxUpdateUnitStateClose,
    // $ajaxSelectAllUser,
    $ajaxSelectScheduleWhereTeam,
    $ajaxAddNewSchedule,
    $ajaxSelectTeamByQuerry,
    $ajaxSelectAllTeam,
    $ajaxAddNewTeam,
    $ajaxUpdateTeamInfo,
    $ajaxSelectRegionByUnitNo,
    $ajaxUpdateUnitRegion,
    $ajaxSelectEmSkillList,
    $ajaxSelectOccupyByQuery,
    $ajaxDeleteOccupy,
    $ajaxUpdateTeamState,
    $ajaxWorkerServiceItemList,
    $ajaxWorkerServiceItemDelete,
    $ajaxWorkerServiceItemUpdate,
    $ajaxBatchAppendServiceItem,
    $ajaxSelectAllCity,
    $ajaxSelectStation,
    $ajaxgetWorkerLeaveList,
    $ajaxsaveWorkerLeave,
    $getStockNoLngLat,
    $getStockNoLngLatV2,

    $ajaxgetDispWorkerList,
    $ajaxUpdateState,
    $ajaxgetDispCity,
    $ajaxaddOrUpdate,
    $ajaxDeleteDispWorker,
    $ajaxworkerSchReportGetList,
    $ajaxworkerSchReportDown
}
